import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@components/shadcn/ui/dialog'
import Title from '@components/typography/Title'
import { classnames } from '@tools/common'

interface ModalProps {
  children: React.ReactNode
  footerChildren?: React.ReactNode
  title: string
  onOpenChange?: () => void
  open?: boolean
  className?: string
  titleIcon?: React.ReactNode
}

export const Modal = ({
  onOpenChange,
  open,
  children,
  footerChildren,
  title,
  className,
  titleIcon,
}: ModalProps) => {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogTitle />
      <DialogContent
        aria-describedby=""
        className={classnames('sm:max-w-[600px] p-0', className)}
      >
        <div
          className={classnames(
            'flex gap-4 border-b py-5 px-2 sm:px-6 items-center',
            {
              'py-4': titleIcon,
            },
          )}
        >
          {titleIcon && titleIcon}

          <Title as="h5" className="text-primary">
            {title}
          </Title>
        </div>

        <div className="overflow-auto md:h-fit h-[calc(100vh-180px)]">
          {children}
        </div>

        {footerChildren && (
          <DialogFooter className="border-t py-[14px] px-2 sm:px-6">
            {footerChildren}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}
